import { AlertTriangle, Zap, CheckCircle2, Clock, Pause } from 'lucide-react';

export const STATUS_META = {
  on_track:  { label: 'On track', color: 'bg-slate-100 text-slate-700 border-slate-200',       Icon: Clock },
  advanced:  { label: 'Advanced', color: 'bg-blue-100 text-blue-800 border-blue-200',          Icon: Zap },
  delayed:   { label: 'Delayed',  color: 'bg-amber-100 text-amber-800 border-amber-200',       Icon: Pause },
  blocked:   { label: 'Blocked',  color: 'bg-rose-100 text-rose-800 border-rose-200',          Icon: AlertTriangle },
  done:      { label: 'Done',     color: 'bg-emerald-100 text-emerald-800 border-emerald-200', Icon: CheckCircle2 },
};
export const STATUS_KEYS = Object.keys(STATUS_META);
// Display order for grouped views: most urgent first.
export const GROUP_ORDER = ['blocked', 'delayed', 'on_track', 'advanced', 'done'];
